export default function InProgress() {
    return (
        <div style={{ opacity: '0.4', textAlign: 'center', marginTop: '20px' }}>
            <h1>IN PROGRESS</h1>
        </div>
    )
}